@if (!showAllCurrencies) {
  <div class="currency-number large">
    {{ fundsAll.default_total | xsactCurrency:fundsAll.default_currency:'hundredth' }}
  </div>
}
@if (showAllCurrencies && fundsAll) {
  <div class="btn-group" dropdown [isDisabled]="(funds | keyvalue).length <= 1">
    <button type="button" class="currency-number large dropdown-toggle" dropdownToggle aria-haspopup="true" aria-expanded="false">
      {{ funds[selectedCurrency] | xsactCurrency:selectedCurrency:'hundredth' }}
    </button>
    @if ((funds | keyvalue).length > 1) {
      <ul class="dropdown-menu" *dropdownMenu role="menu">
        @for (currency of funds | keyvalue; track currency) {
          @if (TokenClass[currency.key] && currency.key != TokenClass.TEST) {
            <li>
              <a class="currency-number" href="javascript:void(0);" (click)="selectCurrency($any(currency.key))">
                {{ funds[currency.key] | xsactCurrency:currency.key:'hundredth' }}
              </a>
            </li>
          }
        }
      </ul>
    }
  </div>
}
